import React from 'react';

import { WpTooltip, WpTooltipContent, WpTooltipTrigger, Placement } from 'Wpds/components/tooltip';

import './QuestionMark.scss';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  tooltip: string;
  className?: string;
  placement?: Placement;
};

function QuestionMark({ tooltip, className, placement = 'right' }: Props) {
  return (
    <WpTooltip placement={placement}>
      <WpTooltipTrigger>
        <span className={` ml-2 workspace-question-mark ${className}`}>
          <WpIcon name="question-circle" />
        </span>
      </WpTooltipTrigger>
      <WpTooltipContent>{tooltip}</WpTooltipContent>
    </WpTooltip>
  );
}

export default QuestionMark;
